import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: 'bizflex-error-page-not-acceptable',
  standalone: true,
  imports: [],
  templateUrl: './not-acceptable.component.html',
  styleUrls: ['./not-acceptable.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotAcceptableComponent {
  @HostBinding('class') private readonly hostClass = 'portal-section text-center';
}
